import * as Q from '../graphql/queries/multibss/component-identifier.query';
import { ApiResponse, query } from './api';
import * as T from './component-identifier.types';

interface ComponentIdentifierInterface {
  componentIdentifier(
    billingCustomerId: string,
    componentIdentifier: T.ComponentIdentifierParameter
  ): ApiResponse<T.ComponentIdentifier>;
  componentIdentifierForProduct(
    billingCustomerId: string,
    componentIdentifier: T.ComponentIdentifierParameter,
    assignedProductId: string | undefined
  ): ApiResponse<T.ComponentIdentifier>;
  canRefreshEntitlements(
    billingCustomerId: string,
    productId: string,
    subProductId: string
  ): ApiResponse<T.ComponentIdentifier>;
  canRequestPrivacy(billingCustomerId: string): ApiResponse<T.ComponentIdentifier>;
  canComplaintPrivacy(billingCustomerId: string): ApiResponse<T.ComponentIdentifier>;
  canDeletePrivacy(billingCustomerId: string): ApiResponse<T.ComponentIdentifier>;
  canUpdatePhoneSettings(
    billingCustomerId: string,
    componentIdentifier: T.ComponentIdentifierParameter,
    assignedProductId: string | undefined
  ): ApiResponse<T.ComponentIdentifier>;
  canChangeSecretCircle(billingCustomerId: string): ApiResponse<T.ComponentIdentifier>;
}

export const ComponentIdentifierApi: ComponentIdentifierInterface = {
  componentIdentifier(billingCustomerId, componentIdentifier) {
    return query({
      query: Q.getComponentIdentifierQuery,
      variables: {
        billingCustomerId,
        componentIdentifier,
      },
      name: 'getComponentIdentifier',
    }).then(({ getComponentIdentifier }: { getComponentIdentifier: T.ComponentIdentifier }) => ({
      data: {
        enabled: getComponentIdentifier.enabled,
      },
    }));
  },

  componentIdentifierForProduct(billingCustomerId, componentIdentifier, assignedProductId) {
    return query({
      query: Q.getComponentIdentifierForProductQuery,
      variables: {
        billingCustomerId,
        componentIdentifier,
        assignedProductId,
      },
      name: 'getComponentIdentifierForProduct',
    }).then(({ getComponentIdentifierForProduct }: { getComponentIdentifierForProduct: T.ComponentIdentifier }) => ({
      data: {
        enabled: getComponentIdentifierForProduct.enabled,
      },
    }));
  },

  canRefreshEntitlements(billingCustomerId, productId, subProductId) {
    return query({
      query: Q.canRefreshEntitlementsQuery,
      variables: {
        billingCustomerId,
        productId,
        subProductId,
      },
      name: 'canRefreshEntitlements',
    }).then(({ canRefreshEntitlements }: { canRefreshEntitlements: T.ComponentIdentifier }) => ({
      data: canRefreshEntitlements,
    }));
  },

  canRequestPrivacy(billingCustomerId) {
    return query({
      query: Q.canRequestPrivacyQuery,
      variables: {
        billingCustomerId,
      },
      name: 'canRequestPrivacy',
    }).then(({ canRequestPrivacy }: { canRequestPrivacy: T.ComponentIdentifier }) => ({ data: canRequestPrivacy }));
  },

  canComplaintPrivacy(billingCustomerId) {
    return query({
      query: Q.canComplaintPrivacyQuery,
      variables: {
        billingCustomerId,
      },
      name: 'canComplaintPrivacy',
    }).then(({ canComplaintPrivacy }: { canComplaintPrivacy: T.ComponentIdentifier }) => ({
      data: canComplaintPrivacy,
    }));
  },

  canDeletePrivacy(billingCustomerId) {
    return query({
      query: Q.canDeletePrivacyQuery,
      variables: {
        billingCustomerId,
      },
      name: 'canDeletePrivacy',
    }).then(({ canDeletePrivacy }: { canDeletePrivacy: T.ComponentIdentifier }) => ({ data: canDeletePrivacy }));
  },

  canUpdatePhoneSettings(billingCustomerId, componentIdentifier, assignedProductId) {
    return query({
      query: Q.canUpdatePhoneSettingsQuery,
      variables: {
        billingCustomerId,
        componentIdentifier,
        assignedProductId,
      },
      name: 'canUpdatePhoneSettings',
    }).then(({ canUpdatePhoneSettings }: { canUpdatePhoneSettings: T.ComponentIdentifier }) => ({
      data: {
        enabled: canUpdatePhoneSettings.enabled,
      },
    }));
  },

  canChangeSecretCircle(billingCustomerId) {
    return query({
      query: Q.canChangeSecretCircleQuery,
      variables: {
        billingCustomerId,
      },
      name: 'canChangeSecretCircle',
    }).then(({ canChangeSecretCircle }: { canChangeSecretCircle: T.ComponentIdentifier }) => ({
      data: canChangeSecretCircle,
    }));
  },
};
